import { useEffect, useRef } from "react";
import { AccountProfileActionResponse } from "~/entities/actions/types";
import useCreateAccountWizard from "~/hooks/useCreateAccountWizard";
import ErrorMessage from "./ErrorMessage";
import Field from "./Field";
import SubmitButton from "./SubmitButton";

type Props = {
  onSuccess: () => void;
  isActive: boolean;
};

const BusinessProfile: React.FC<Props> = ({ onSuccess, isActive }) => {
  const { errors, fetcher } =
    useCreateAccountWizard<AccountProfileActionResponse>(onSuccess);

  const nameRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  const businessRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (errors["full_name"] && nameRef.current) {
      nameRef.current.focus();
    } else if (errors["phone"] && phoneRef.current) {
      phoneRef.current.focus();
    } else if (errors["business_name"] && businessRef.current) {
      businessRef.current.focus();
    } else if (isActive && nameRef.current) {
      nameRef.current.focus();
    }
  }, [isActive, errors]);

  if (!isActive) return null;

  return (
    <fetcher.Form
      method="post"
      action="/resources/create-account-wizard"
      className="flex flex-col gap-5"
      data-testid="business-profile-form"
    >
      <input
        type="hidden"
        name="intent"
        value="business_profile"
      />
      <h2 className="text-[20px] text-blue900 font-sans mt-0 uppercase font-bold">
        Complete profile to unlock wholesale pricing.
      </h2>

      <ErrorMessage error={errors["form"]} />

      <Field
        label="Name"
        name="full_name"
        ariaLabel="Enter your first and last name"
        placeholder="John Smith"
        error={errors["full_name"]}
        ref={nameRef}
      />

      <Field
        label="Phone Number"
        name="phone"
        ariaLabel="Enter your 10-digit phone number"
        placeholder="(555) 555-5555"
        error={errors["phone"]}
        ref={phoneRef}
      />

      <Field
        label="Business Name"
        name="business_name"
        ariaLabel="Enter your business name"
        error={errors["business_name"]}
        ref={businessRef}
      />

      <SubmitButton
        disabled={fetcher.state === "submitting"}
        label="Finish up"
      />
    </fetcher.Form>
  );
};

export default BusinessProfile;
